import { Component, Input } from '@angular/core';
import { IconComponent } from '../../../../shared/components/icon/icon.component';
import { CounterMetric } from '../../../../shared/models/interfaces/dashboard/dashboard.interface';

@Component({
  selector: 'l-dashboard-counter-metric-card',
  standalone: true,
  imports: [IconComponent],
  templateUrl: './dashboard-counter-metric-card.component.html',
})
export class DashboardCounterMetricCardComponent {

  @Input({ required: true })
  public metric!: CounterMetric;

}
